// api/apis.js
const ENDPOINTS = {
  auth: {
    login: "/auth/login",
    register: "/auth/register",
    verify: "/auth/verify",
  },
  public: {
    courses: {
      list: "/courses/public/",
      details: (id) => `/courses/public/${id}`,
    },
    internships: {
      list: "/internships/public/",
      details: (id) => `/internships/${id}`,
    },
    contactus: "/public/contactUs"
  }
  
};

export default ENDPOINTS;
